// Service worker registration for GiftBox PWA (CRA-compatible)

export function register() {
  if (!('serviceWorker' in navigator)) return;

  // Production always; local opt-in with REACT_APP_ENABLE_SW=true
  const enabled =
    process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENABLE_SW === 'true';
  if (!enabled) return;

  const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              console.info('[PWA] Update available — refresh to get the latest version.');
            }
          };
        };
      })
      .catch((err) => {
        console.warn('[PWA] Service worker registration failed:', err);
      });
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
